import { RouteConfig } from '../../routing/types'

const ROUTE: RouteConfig = {
  name: 'collections',
  path: () => '/collections',
}

export default ROUTE
